import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { AxthenticationService } from 'app/services';
import { TxnService } from './../../../../../services/txn.service';
import { StatusService } from 'ui-components/common';

@Component({
    standalone: false,
    selector: 'gib-logout-confirm-popup',
    templateUrl: 'logout.confirm.popup.component.html'
})
export class LogoutConfirmPopupComponent extends BaseComponent {

    /**
     * 顯示編輯我的最愛對話框
     */
    @Input() display: boolean = false;

    /**
     * popup於關閉時的Call Back
     */
    @Output() callback = new EventEmitter();

    title: string = '';

    constructor(
        private axthenticationService: AxthenticationService,
        private statusService: StatusService, public txnService: TxnService) {
        super(txnService);
    }

    ngOnInit() {
        // console.log('LogoutConfirmPopupComponent init...');
    }

    onClose() {
        this.callback.emit(false);
    }

    /**
     * 要顯示前先依內容重新計算高度
     */
    onShow() {
        this.title = this.txnService.transform('訊息', 'chm00004690', null);
    }

    /**
     * 確定登出
     */
    onConfirm(): void {
        this.callback.emit(true);
    }
    onHide() {
        this.callback.emit(false);
    }


}
